// extracted by mini-css-extract-plugin
export default {"Faq":"In8TknPQXOgc5CqWAk6D"};